import React from 'react'
import ModelCard from './ModelCard'
import './style.scss'

export default function ModelSection({ handleClick }) {
    return (
        <div className="landing-model" data-theme="light">
            <div className="landing-container">
                <h2>Try world-class AI models.
                    All in one place.</h2>
                <p>Zeely runs multiple AI models to understand your idea, build a story, and animate it</p>
                <div className="landing-model-wrapper">
                    <ModelCard handleClick={handleClick} source={'button_3'} img='landing/m1.webp' title='One login.<br>Multiple AI models.' text='Tap into leading AI models in one place, so you can blend their strengths and get more creative options from every idea' />
                    <ModelCard handleClick={handleClick} source={'button_4'} img='landing/m3.webp' title='The AI you need.<br>When you need it.' text='Going big with a new video or just polishing what you’ve got, Zeely leans on the right model so things look and feel on point' />
                    <ModelCard handleClick={handleClick} source={'button_5'} img='landing/m2.webp' title='Power that feels pro.<br>Controls that feel simple.' text='Plug into serious AI capabilities without losing control. Adjust scenes, pacing, and style in a few taps — it’s all there by default.' />

                </div>
            </div>
        </div>
    )
}
